/* eslint-disable no-shadow */
const state = {
	selectedProduct: [],
	selectedWpVariantProducts: [],
	selectedProductId: String,
	selectedVariant: String,
	availableVendors: []
}

const getters = {
	getSelectedProduct: state => state.selectedProduct,
	getSelectedWpVariantProducts: state => state.selectedWpVariantProducts,
	getSelectedProductCount: state => state.selectedProduct.length,
	getSelectedProductId: state => state.selectedProductId,
	getSelectedVariant: state => state.selectedVariant,
	getAvailableVendors: state => state.availableVendors,
	getAllAvailableVendors: (state) => {
		if (state.selectedProduct && state.selectedProduct[0] && state.selectedProduct[0].vendor_IDs) {
			return state.selectedProduct[0].vendor_IDs
		}
		return []
	},
	getAllAvailableVendorInventories: (state) => {
		if (state.selectedProduct && state.selectedProduct[0] &&
      state.selectedProduct[0].vendor_product_inventories) {
			return state.selectedProduct[0].vendor_product_inventories
		}
		return []
	}
}

const mutations = {
	setSelectedProductMutation: (state, payload) => {
		const products = JSON.parse(JSON.stringify(payload))
		state.selectedProduct = products
	},
	setSelectedWpVariantProductsMutation: (state, payload) => {
		const products = JSON.parse(JSON.stringify(payload))
		state.selectedWpVariantProducts = products
	},
	clearSelectedProductMutation: (state) => {
		state.selectedProduct = []
	},
	setSelectedProductIdMutation: (state, payload) => {
		state.selectedProductId = payload
	},
	setSelectedVariantMutation: (state, payload) => {
		state.selectedVariant = payload
	},
	setAvailableVendorsMutation: (state, payload) => {
		state.availableVendors = payload
	}
}

const actions = {
	setSelectedProductData: ({
		commit
	}, payload) => {
		commit('setSelectedProductMutation', payload)
	},
	setSelectedWpVariantProductsData: ({
		commit
	}, payload) => {
		commit('setSelectedWpVariantProductsMutation', payload)
	},
	clearSelectedProductData: ({
		commit
	}) => {
		commit('clearSelectedProductMutation')
	},
	setSelectedProductIdData: ({
		commit
	}, payload) => {
		commit('setSelectedProductIdMutation', payload)
	},
	setSelectedVariantData: ({
		commit
	}, payload) => {
		commit('setSelectedVariantMutation', payload)
	},
	setAvailableVendorsData: ({
		commit
	}, payload) => {
		commit('setAvailableVendorsMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
